import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetFundraisingStats = () => {
  return useQuery({
    staleTime: 1000 * 10,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.investing.fundraising_stats],
    queryFn: () =>
      investingService.fundraisingStats().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
